"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var modal_1 = __importDefault(require("../../../plugins/modal"));
var decode_html_1 = __importDefault(require("../../../utils/decode-html"));
var format_price_1 = __importDefault(require("../../../utils/format-price"));
exports.default = (function (_a) {
    var e_1, _b;
    var isDiscount = _a.isDiscount, productVariantArr = _a.productVariantArr, handleCloseModalClick = _a.handleCloseModalClick, handleIncreaseClick = _a.handleIncreaseClick;
    var product = productVariantArr && productVariantArr[0];
    var variant = productVariantArr && productVariantArr[1];
    var handleCloseModal = function () { return handleCloseModalClick(null); };
    // this is a list of image srcs so that eventually a carousel can be used. need to make images more consistent across products first
    var imgSrc = (function () {
        if (variant === null || variant === void 0 ? void 0 : variant.featured_image) {
            return [variant.featured_image.src];
        }
        if (product === null || product === void 0 ? void 0 : product.featured_image) {
            return [product.featured_image];
        }
        if (product === null || product === void 0 ? void 0 : product.images.length) {
            return [product.images[0].src];
        }
    })();
    var productImages = imgSrc === null || imgSrc === void 0 ? void 0 : imgSrc.map(function (img, i) { return React.createElement("img", { key: i, style: { maxHeight: '250px' }, src: img }); });
    var productOptions = product === null || product === void 0 ? void 0 : product.options;
    // figure out if options is a string or an object
    var isOptionsStringArray = function (opts) { return typeof opts === 'string'; };
    var optionStringArray = [];
    var variantOptions = variant ? [variant.option1, variant.option2, variant.option3] : [];
    if (productOptions) {
        try {
            for (var productOptions_1 = __values(productOptions), productOptions_1_1 = productOptions_1.next(); !productOptions_1_1.done; productOptions_1_1 = productOptions_1.next()) {
                var option = productOptions_1_1.value;
                if (isOptionsStringArray(option)) {
                    optionStringArray.push(option);
                }
                else {
                    optionStringArray.push(option.name);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (productOptions_1_1 && !productOptions_1_1.done && (_b = productOptions_1.return)) _b.call(productOptions_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    // align every even indexed option (e.g. scent, size) to the left, and odd ones to the right
    var options = optionStringArray.length > 0 ? (optionStringArray.map(function (option, i) { return (React.createElement("div", { key: i, className: i % 2 === 0 ? 'small-6 text-left' : 'small-6 text-right' }, option)); })) : (React.createElement(React.Fragment, null));
    // align every even indexed option value (e.g. Apple Blossom, 10oz) to the left, and odd ones to the right
    var optionValues = variantOptions ? (variantOptions.map(function (option, i) { return (React.createElement("div", { key: i, className: i % 2 === 0 ? 'small-6 text-left' : 'small-6 text-right' }, option)); })) : (React.createElement(React.Fragment, null));
    // get product description config from description or body_html
    var productDescription = (product === null || product === void 0 ? void 0 : product.description) || (product === null || product === void 0 ? void 0 : product.body_html) || '{}';
    var productSettingsRegex = /{(.*)}/g;
    var productSettingsMatch = productSettingsRegex.exec(productDescription) || [];
    var productSettings;
    try {
        if (!productSettingsMatch[0])
            throw new Error('0th match is undefined or null');
        productSettings = JSON.parse(productSettingsMatch[0]);
    }
    catch (e) {
        console.error('Error Parsing Product Details: ', e);
        productSettings = {};
    }
    var productHex = (variant && productSettings.hex && productSettings.hex[variant.title]) || '#96D4E9';
    var productFeatures = productSettings.features ? (productSettings.features.map(function (feature, i) { return (React.createElement("div", { key: i, className: 'padding-vertical-2', style: i + 1 !== productSettings.features.length ? { borderBottom: '2px solid #FFB3AB' } : {} }, (0, decode_html_1.default)(feature))); })) : (React.createElement(React.Fragment, null));
    return (React.createElement(modal_1.default, { closeClassNames: 'ss-delete text-white h2', isOpen: !!variant, handleClose: handleCloseModal, style: { content: { borderRadius: '15px' } } }, (function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("div", { className: 'text-center', style: { backgroundColor: productHex } }, productImages),
                React.createElement("div", { className: 'grid-container padding-horizontal-5 padding-bottom-5' },
                    React.createElement("div", { className: 'h3 font-bold padding-vertical-5' }, productSettings.title || (product === null || product === void 0 ? void 0 : product.title.split(isDiscount ? '(Bundle) (Discount) ' : '(Bundle) ')[1])),
                    React.createElement("div", { className: 'divider', style: { backgroundColor: productHex, height: '6px', width: '50px' } }),
                    React.createElement("div", { className: 'hide-for-medium padding-vertical-5 text-nobel' }, productSettings.description),
                    React.createElement("div", { className: 'show-for-medium padding-vertical-5 text-nobel', style: { width: '800px' } }, productSettings.description),
                    // it's assumed that if the first option is "Title" that it's the only variant and we don't need to show variant option
                    optionStringArray[0] !== 'Title' && (React.createElement("div", { className: 'padding-bottom-5' },
                        React.createElement("div", { className: 'grid-x font-bold' }, optionValues),
                        React.createElement("div", { className: 'grid-x text-nobel' }, options))),
                    variant && (React.createElement("button", { id: 'variant-details-modal-add-to-cart' // for GA
                        , className: 'button bg-light-wisteria width-100 padding-vertical-5', onClick: function () {
                            handleIncreaseClick(variant)();
                            handleCloseModal();
                        } },
                        "Add To Bundle - ",
                        (0, format_price_1.default)(variant.price)))),
                React.createElement("div", { className: 'bg-alabaster' },
                    React.createElement("div", { className: 'grid-container padding-horizontal-5 padding-bottom-10' },
                        React.createElement("div", { className: 'h3 font-bold padding-top-5' }, "Features"),
                        React.createElement("div", { className: 'hide-for-medium padding-top-2' }, productFeatures),
                        React.createElement("div", { className: 'show-for-medium padding-top-2', style: { width: '800px' } }, productFeatures))),
                React.createElement("div", { className: 'padding-vertical-5 text-center text-nobel', style: { borderTop: 'solid', borderTopWidth: '1px', borderColor: '#EDEBEB', marginLeft: '-10px', marginRight: '-10px', cursor: 'pointer' }, onClick: function () { return handleCloseModal(); } }, "CLOSE"))));
    })()));
});
